import React from 'react';
import { useQueryLoader } from 'react-relay';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import QUERY, {
	type SandboxEchoPageQuery,
} from '@atlassian/jira-relay/src/__generated__/SandboxEchoPageQuery.graphql';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { sandboxEchoPageRelayResource } from '@atlassian/jira-router-resources-sandbox/src/index.tsx';

export const LazyForPaintSandboxEchoPage = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-lazy-for-paint-sandbox-echo-page" */ './SandboxEchoPage.tsx'
		),
	),
);

export const SelfStartingSandboxEchoPage = (): React.JSX.Element => {
	const [queryReference, loadQuery] = useQueryLoader<SandboxEchoPageQuery>(QUERY);
	if (queryReference == null) {
		loadQuery({
			cloudId: '7088b486-bbf4-4e1f-9195-412bfac4be28',
			enableDefer: true,
			skipLongQuery: true,
		});
		return <small>Triggering query...</small>;
	}

	const props = {
		queries: { pageQueryRef: queryReference },
		props: {},
		extraProps: {},
		entryPoints: {},
	};

	return (
		<>
			<small>Self-starting sandbox echo page</small>
			<Placeholder name="self-starting-sandbox-echo-page" fallback="Loading echo page...">
				<LazyForPaintSandboxEchoPage {...props} />
			</Placeholder>
		</>
	);
};

export const AsyncSandboxEchoPage = (): React.JSX.Element => {
	const { queryReference } = useRelayResource(sandboxEchoPageRelayResource);

	const props = queryReference
		? {
				queries: { pageQueryRef: queryReference },
				props: {},
				extraProps: {},
				entryPoints: {},
			}
		: null;

	return (
		<>
			<small>Async sandbox echo page</small>
			<Placeholder name="async-sandbox-echo-page" fallback="Loading echo page...">
				{props && <LazyForPaintSandboxEchoPage {...props} />}
			</Placeholder>
		</>
	);
};
